module.exports = __webpack_public_path__ + "static/img/科创金融服务系统dialog.7f6486a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/科创金融服务系统dialog.png
// module id = HRcC
// module chunks = 1